import MindsetsJsSDK from "mindsets-js-sdk";

export const SET_QUESTION_PRACTICE_SKILL_UPDATED = '[question_practice_skills] Set Question Practice Skills Updated';

export const SetQuestionPracticeSkillsUpdatedAction = payload => ({
    type: SET_QUESTION_PRACTICE_SKILL_UPDATED,
    payload
});
export const GetQuestionPracticeSkillPDFDataAction = (challenge_code, practice_identifier) => () => {
    return MindsetsJsSDK().API.get(`challenge_codes/${challenge_code}/practices/${practice_identifier}/rubric`, {buffer: true});
};